export default function Play() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M40 75C20.67 75 5 59.33 5 40C5 20.67 20.67 5 40 5C59.33 5 75 20.67 75 40C75 59.33 59.33 75 40 75ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z" fill="white" />
      <path d="M31.356 25.2771C32.1887 24.8486 33.1911 24.9214 33.9531 25.4657L51.4531 37.9657C52.1101 38.435 52.5 39.1926 52.5 40C52.5 40.8074 52.1101 41.5651 51.4531 42.0343L33.9531 54.5343C33.1911 55.0787 32.1887 55.1514 31.356 54.7229C30.5234 54.2944 30 53.4365 30 52.5V27.5C30 26.5635 30.5234 25.7056 31.356 25.2771Z" fill="white" />
    </svg>

  );
}